import { createFileRoute } from '@tanstack/react-router'
import { ConsolidatedReportPage } from '@/features/admin/consolidated-report'
import { requireRole } from '@/lib/auth-guards'

export const Route = createFileRoute('/_authenticated/consolidated-report/')({
  component: ConsolidatedReportPage,
  beforeLoad: requireRole(['admin']),
})
